import banner from "./banner.gif";
import elearning from "./elearning.webp";
import vc from "./Gouni_vc.png";
import logo from "./logo.webp";
import groupPix from "./gouni.png";
import flayer from "./jupeb.png";
import fees from "./payment.webp";
import account from "./account.png";
import architect from "./arch.png";
import banking from "./banking.webp";
import bio from "./bio.webp";
import biochem from "./biochemistry.png";
import biology from "./gouni-biology.png";
import biotech from "./biotchnology.png";
import logo2 from "./gologo.png";
import enuguGoUNi from "./enugu_gouni.gif";
import visit from "./governorvisit.webp";
import slide1 from "./slide1.png";
import guide from "./exam.png";
import student from "./student.jpg";
import exampix from "./schools_exams.png";
import error404 from "./error.png";
import student1 from "./student1.png";
import student2 from "./student2.png";
import online from "./online.jpeg";
import resultSheet from "./paper.png";





const images = {
  resultSheet,
  slide1,
  online,
  student1,
  student2,
  exampix,
  error404,
  guide,
  student,
  visit,
  enuguGoUNi,
  banner,
  elearning,
  logo2,
  account,
  architect,
  banking,
  bio,
  biochem,
  biology,
  biotech,
  vc,
  logo,
  groupPix,
  flayer,
  fees,
}
export default images;